import { apiRequest } from '@/lib/apiClient';
import type { AppSettings, Eletricista } from '@/types';

export function fetchSettings(): Promise<AppSettings> {
  return apiRequest<AppSettings>('/api/app/definicoes');
}

export function updateSettings(input: Partial<AppSettings>): Promise<AppSettings> {
  return apiRequest<AppSettings>('/api/app/definicoes', { method: 'PUT', body: input });
}

export function fetchEquipa(): Promise<Eletricista[]> {
  return apiRequest<Eletricista[]>('/api/app/equipa');
}
